(function () {
  'use strict';

  var MODAL_ID = 'cpb-after-add-modal';
  var STYLE_ID = 'cpb-after-add-modal-styles';

  /** Liquid でカート URL を埋め込める場合はそちらが確実（多言語ストア向け）。無ければ '/cart' */
  var CART_URL = '/cart';

  /**
   * モーダル用のスタイルを 1 回だけ追加する
   */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '#' +
      MODAL_ID +
      '{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.45);}' +
      '#' +
      MODAL_ID +
      '.is-open{display:flex;}' +
      '#' +
      MODAL_ID +
      ' .cpb-modal__dialog{max-width:420px;width:100%;background:#fff;border-radius:12px;padding:24px;box-shadow:0 16px 48px rgba(0,0,0,.2);text-align: center;}' +
      '#' +
      MODAL_ID +
      ' .cpb-modal__title{margin:0 0 20px;font-size:2.25rem;font-weight:700;}' +
      '#' +
      MODAL_ID +
      ' .cpb-modal__actions{display:flex;gap:12px;flex-wrap:wrap;justify-content:center;}' +
      '#' +
      MODAL_ID +
      ' .cpb-modal__btn{appearance:none;border:1px solid #ccc;background:#fff;color:#111;padding:10px 18px;border-radius:8px;font:inherit;cursor:pointer;}' +
      '#' +
      MODAL_ID +
      ' .cpb-modal__btn--primary{background:#30a743;color:#fff;border-color:#111;}';
    var tag = document.createElement('style');
    tag.id = STYLE_ID;
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  /**
   * モーダル DOM を 1 回だけ作成する
   */
  function ensureModal() {
    injectStyles();
    var existing = document.getElementById(MODAL_ID);
    if (existing) return existing;

    var wrap = document.createElement('div');
    wrap.id = MODAL_ID;
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', MODAL_ID + '-title');
    wrap.innerHTML =
      '<div class="cpb-modal__dialog" role="document">' +
      '  <h2 id="' +
      MODAL_ID +
      '-title" class="cpb-modal__title">カートに追加しました</h2>' +
      '  <div class="cpb-modal__actions">' +
      '    <button type="button" class="cpb-modal__btn" data-cpb-modal-action="continue">買い物を続ける</button>' +
      '    <button type="button" class="cpb-modal__btn cpb-modal__btn--primary" data-cpb-modal-action="cart">カートを見る</button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(wrap);

    /** オーバーレイクリックで閉じる（ダイアログ内クリックは伝播しない） */
    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) closeModal(wrap);
    });

    wrap.querySelector('[data-cpb-modal-action="continue"]').addEventListener('click', function () {
      closeModal(wrap);
    });

    wrap.querySelector('[data-cpb-modal-action="cart"]').addEventListener('click', function () {
      window.location.href = CART_URL;
    });

    return wrap;
  }

  function openModal() {
    var modal = ensureModal();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    /** フォーカスを最初のボタンへ（簡易アクセシビリティ） */
    var firstBtn = modal.querySelector('.cpb-modal__btn');
    if (firstBtn && typeof firstBtn.focus === 'function') firstBtn.focus();
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  /** Esc で閉じる（キーボードユーザー向け） */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = document.getElementById(MODAL_ID);
    if (modal && modal.classList.contains('is-open')) closeModal(modal);
  });

  /**
   * CPB: カート追加完了後にモーダルを表示する
   */
  document.addEventListener('cpb-add-to-cart', function () {
    openModal();
  });
})();